/** 全站 APK 拉取与下载逻辑 */
import { APK_DOWNLOAD_URL } from '@/utlis/siteConfig';

// 站点固定 APK：下载链接始终使用它，避免被接口返回的旧包/外站 APK 覆盖
const FIXED_APK = APK_DOWNLOAD_URL;

export default {
  data() {
    return {
      apk: FIXED_APK,
      from: 'gb',
      filename: 'gb',
    };
  },
  mounted() {
    if (typeof window === 'undefined') return;
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    if (this.$global.GetQueryString('from')) {
      this.reportPromotion();
    }
  },
  methods: {
    // 带推广参数时仅向接口上报渠道信息，返回值不再用于下载，避免旧包覆盖新地址
    reportPromotion() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .catch(() => {});
    },
    /** 直接下载 APK；无链接时跳转下载页 */
    triggerDownload() {
      const target = this.apk || FIXED_APK;
      if (target) {
        this.$global.download(target);
      } else {
        this.$router.push({ name: 'en-download' });
      }
    },
    gotodownload() {
      this.triggerDownload();
    },
  },
};
